import script from "./MainFileInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MainFileInput.vue?vue&type=script&setup=true&lang=js"

import "./MainFileInput.vue?vue&type=style&index=0&id=5414a5a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5414a5a8"]])

export default __exports__